module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, _vm._l((_vm.signatures), function(s) {
    return _c('div', {
      staticClass: "signature"
    }, [_c('div', {
      staticClass: "user-icon"
    }, [(s.isDonation) ? _c('img', {
      attrs: {
        "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/2903/dist/assets/img/ra-ls-forest.svg"
      }
    }) : _vm._e(), _vm._v(" "), (!s.isDonation) ? _c('img', {
      attrs: {
        "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/2903/dist/assets/img/ra-ls-tree.svg"
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "user-name"
    }, [_c('div', {
      staticClass: "signature-name"
    }, [_vm._v("\n        " + _vm._s(_vm.limitSize(s.firstName)) + " " + _vm._s(_vm.limitSize(s.lastName)) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "signature-time"
    }, [_vm._v("\n        planted a " + _vm._s(s.isDonation ? "forest" : "tree") + "\n        " + _vm._s(s.timeDifference) + "\n      ")])])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c79e8696","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=ba0n6m0pdol!./~/string-replace-webpack-plugin/loader.js?id=vjdso5oqwij!./src/components/leaf-relief/LastSignatures.vue
// module id = 683
// module chunks = 0